var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForMinorsTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8588 0C13.6228 0 0.460938 13.1619 0.460938 29.3979C0.460938 45.6339 13.6228 58.7958 29.8588 58.7958C46.0948 58.7958 59.2567 45.6339 59.2567 29.3979C59.2567 13.1619 46.0948 0 29.8588 0ZM35.5881 14.6989C35.5881 15.1358 35.629 15.566 35.7041 15.9824C36.0657 17.9071 37.2047 19.5588 38.7869 20.5894C39.8918 21.3129 41.2012 21.7293 42.6128 21.7293L42.6126 22.8555V26.7802C39.9937 26.7802 37.5659 25.9407 35.588 24.5209V34.7935C35.588 39.9195 31.4144 44.0968 26.2927 44.0968C24.3149 44.0968 22.4735 43.4687 20.9662 42.4108C18.5657 40.7248 16.9972 37.94 16.9972 34.7935C16.9972 29.6606 21.1642 25.4903 26.2859 25.497C26.7155 25.497 27.1315 25.5311 27.5407 25.5858V26.7802L27.5258 26.7874L27.5407 26.787V30.7459C27.1452 30.623 26.7223 30.548 26.2859 30.548C23.9466 30.548 22.0439 32.4523 22.0439 34.7935C22.0439 36.4249 22.9714 37.8377 24.3217 38.5544C24.3343 38.5717 24.3471 38.5889 24.3599 38.6059L24.3826 38.6358C24.3671 38.6058 24.3491 38.5764 24.3286 38.5476C24.9219 38.8616 25.5902 39.039 26.2995 39.039C28.5841 39.039 30.4528 37.2166 30.5346 34.9505L30.5414 14.6989H35.5881Z",
    fill: "#E97737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForMinorsTikTok);
export default __webpack_public_path__ + "static/media/forMinors-tik-tok.ee895ece53186349b81f72b8866ac4ff.svg";
export { ForwardRef as ReactComponent };